import { FUNCTIONALITIES, RELEASE_NOTES } from '../lib/releases';

export function ProductInfo() {
  return <div className="product-info-grid">
    <section className="card product-info" aria-labelledby="functionalities-title">
      <span className="eyebrow">CAPABILITIES</span>
      <h2 id="functionalities-title">Functionalities supported</h2>
      <div className="functionality-groups">
        {FUNCTIONALITIES.map((group) => <article key={group.title}>
          <h3>{group.title}</h3>
          <ul>{group.items.map((item) => <li key={item}>{item}</li>)}</ul>
        </article>)}
      </div>
    </section>
    <section className="card product-info" aria-labelledby="release-notes-title">
      <span className="eyebrow">CHANGELOG</span>
      <h2 id="release-notes-title">Release notes</h2>
      <div className="release-list">
        {RELEASE_NOTES.map((release, index) => <details key={release.version} open={index === 0}>
          <summary><span><strong>v{release.version}</strong> {release.title}</span>{release.date && <time dateTime={release.date}>{release.date}</time>}</summary>
          <ul>{release.changes.map((change) => <li key={change}>{change}</li>)}</ul>
        </details>)}
      </div>
    </section>
  </div>;
}
